module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-16-7e7d4281c84c61e5f9e47ec73d54f8e0.svg";